var _style, _ellipse, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimatedRobot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    role: "img",
    "aria-label": "Cute talking robot",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* ensure transforms use element box center */\n    .animable { transform-box: fill-box; transform-origin: center; }\n\n    /* gentle bobbing of the whole robot */\n    @keyframes bob {\n      0%   { transform: translateY(0px); }\n      50%  { transform: translateY(-10px); }\n      100% { transform: translateY(0px); }\n    }\n\n    /* mouth scale to simulate talking */\n    @keyframes talk {\n      0%   { transform: scaleY(1) scaleX(1); }\n      20%  { transform: scaleY(0.25) scaleX(0.55); }\n      40%  { transform: scaleY(1) scaleX(1); }\n      60%  { transform: scaleY(0.35) scaleX(0.75); }\n      80%  { transform: scaleY(0.9) scaleX(0.95); }\n      100% { transform: scaleY(1) scaleX(1); }\n    }\n\n    /* blink: scale Y of eye content to 0 briefly */\n    @keyframes blink {\n      0%, 90%, 100% { transform: scaleY(1); }\n      92% { transform: scaleY(0.05); }\n      95% { transform: scaleY(1); }\n    }\n\n    /* apply animations */\n    #robotGroup { animation: bob 2.2s ease-in-out infinite; }\n    #mouthInner { animation: talk 1.2s ease-in-out infinite; transform-origin: center; transform-box: fill-box; }\n    #leftEyeInner, #rightEyeInner { animation: blink 3.5s steps(1,end) infinite; transform-origin: center; transform-box: fill-box; }\n\n    /* subtle shine on the screen */\n    .screenShine { opacity: 0.12; }\n\n    /* small shadow */\n    .shadow { opacity: 0.12; filter: blur(6px); }\n  ")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "shadow",
    cx: 300,
    cy: 540,
    rx: 120,
    ry: 22,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "robotGroup",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,370)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -40,
    width: 240,
    height: 160,
    rx: 36,
    ry: 36,
    fill: "#E6EEF8",
    stroke: "#B6C9D9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -78,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#D6E6F6",
    stroke: "#B6C9D9",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -90,
    width: 300,
    height: 180,
    rx: 36,
    ry: 36,
    fill: "#2F4B7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: -70,
    width: 264,
    height: 140,
    rx: 24,
    ry: 24,
    fill: "#0B1220"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "screenShine",
    x: -132,
    y: -70,
    width: 264,
    height: 140,
    rx: 24,
    ry: 24,
    fill: "#ffffff",
    transform: "skewX(-12) translate(12 -8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyes",
    transform: "translate(0,-10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -18,
    width: 60,
    height: 36,
    rx: 18,
    ry: 18,
    fill: "#071422"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "leftEyeInner",
    x: -22,
    y: -12,
    width: 44,
    height: 24,
    rx: 12,
    ry: 12,
    fill: "#9EE9FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: -6,
    r: 3.2,
    fill: "#ffffff",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -18,
    width: 60,
    height: 36,
    rx: 18,
    ry: 18,
    fill: "#071422"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rightEyeInner",
    x: -22,
    y: -12,
    width: 44,
    height: 24,
    rx: 12,
    ry: 12,
    fill: "#9EE9FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: -6,
    r: 3.2,
    fill: "#ffffff",
    opacity: 0.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mouth",
    transform: "translate(0,54)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -56,
    y: -30,
    width: 112,
    height: 36,
    rx: 18,
    ry: 18,
    fill: "#071422"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mouthInner",
    x: -44,
    y: -24,
    width: 88,
    height: 24,
    rx: 12,
    ry: 12,
    fill: "#FF9A76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -22,
    width: 12,
    height: 34,
    rx: 6,
    fill: "#E6EEF8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -32,
    r: 12,
    fill: "#FFDD57",
    stroke: "#D6B14A",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,300) rotate(-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -10,
    width: 80,
    height: 26,
    rx: 12,
    ry: 12,
    fill: "#E6EEF8",
    stroke: "#B6C9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 3,
    r: 18,
    fill: "#E6EEF8",
    stroke: "#B6C9D9",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450,300) rotate(6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -66,
    y: -10,
    width: 80,
    height: 26,
    rx: 12,
    ry: 12,
    fill: "#E6EEF8",
    stroke: "#B6C9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -68,
    cy: 3,
    r: 18,
    fill: "#E6EEF8",
    stroke: "#B6C9D9",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,470)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: 0,
    width: 160,
    height: 30,
    rx: 14,
    ry: 14,
    fill: "#DFEAF4",
    stroke: "#B6C9D9",
    strokeWidth: 4
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cute talking robot with blinking eyes and mouth animation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedRobot);
export default __webpack_public_path__ + "static/media/animatedRobot.87ef4fccf874e250bca8cd23cc3dbf83.svg";
export { ForwardRef as ReactComponent };